import React, { memo, useState } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { LocalShipping } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import SendEmailToAramexDialog from "./SendEmailToAramexDialog";
import { DownloadExcelDialog } from "src/_modules/common";

/**
 * AdminActions - Action buttons displayed for admin users
 */
function AdminActions({
  status,
  selectedOrdersIds,
  selectedOrders,
  isValidatingWarehouses,
  formattingLoading,
  isDownloadingAwb,
  onCreateShipment,
  onDownloadAwb
}) {
  const { t } = useTranslation();

  const showAwbButton = ![
    "ORDER_PENDING",
    "ALL_ORDERS",
    "ORDER_CANCELED",
    "ORDER_COMPLETED"
  ].includes(status);


  return (
    <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
      {/* Select Shipping Company Button */}
      {status === "ORDER_PENDING" && (
        <LoadingButton
          id="choses-company-order"
          loading={isValidatingWarehouses || formattingLoading}
          loadingPosition="start"
          startIcon={<LocalShipping />}
          sx={{ textTransform: "none" }}
          variant="contained"
          color="primary"
          disabled={
            !selectedOrdersIds.length ||
            isValidatingWarehouses ||
            formattingLoading
          }
          onClick={onCreateShipment}
        >
          {t("Select Shipping Company")}
        </LoadingButton>
      )}
      {showAwbButton && (
        <LoadingButton
          loading={isDownloadingAwb}
          startIcon={<LocalShipping />}
          sx={{ textTransform: "none" }}
          variant="contained"
          color="primary"
          disabled={!selectedOrdersIds.length}
          onClick={onDownloadAwb}
        >
          {t("DownLoad AWB")}
        </LoadingButton>
      )}
      {status === "ORDER_ASSIGNED_TO_SHIPPING_COMPANY" && (
        <SendEmailToAramexDialog shipments={selectedOrders} />
      )}
    </Box>
  );
}

AdminActions.propTypes = {
  status: PropTypes.string.isRequired,
  selectedOrdersIds: PropTypes.array.isRequired,
  selectedOrders: PropTypes.array.isRequired,
  isValidatingWarehouses: PropTypes.bool,
  formattingLoading: PropTypes.bool,
  isDownloadingAwb: PropTypes.bool,
  onCreateShipment: PropTypes.func.isRequired,
  onDownloadAwb: PropTypes.func.isRequired,
};

AdminActions.defaultProps = {
  isValidatingWarehouses: false,
  formattingLoading: false,
  isDownloadingAwb: false,
};

export default memo(AdminActions);
